import React from 'react';
import "./css/Approach2.css";
import chair from "../assets/1table2chair.png"
import { Link } from 'react-router-dom';
import svg1 from "../assets/approachsvg1.svg";
import svg2 from "../assets/approachsvg2.svg";
import svg3 from "../assets/approachsvg3.svg";

const Approach2 = () => {
    const data = [
        {
            img: svg1,
            heading: "Custom Design",
            para: "We create bespoke wooden solutions tailored to your space. Our expert craftsmen blend traditional techniques with modern design to bring your vision to life."
        },
        {
            img: svg2,
            heading: "Master Crafting",
            para: "Using premium hardwoods and precision tools, our skilled artisans handcraft each piece with meticulous attention to detail and superior workmanship."
        },
        {
            img: svg3,
            heading: "Perfect Delivery",
            para: "We ensure impeccable installation and finishing, delivering wooden masterpieces that enhance your space with timeless beauty and functionality."
        }
    ]

    return (
        <section className="approach-container-main add-main-approach add-remove-border">
            <div className='approach-container-main-content1 add-some'>
                <div className='approach-container-main-content1-content1 add-in-content1'>
                    <div className='approach-image-div add-some-img'>
                        <img src={chair} alt="Dhiman Wood Works Craftsmanship"/>
                    </div>
                    <div className='approach-container-main-content1-content1-content1 add-some-content1'>
                        <div className='text-div-approach'>
                            <h1 className='heading-small'>Excellence in Wood Crafting</h1>
                            <p className='paragraph'>Dhiman Wood Works delivers masterful craftsmanship in custom furniture, cabinetry, and architectural woodwork. Each piece reflects our commitment to quality and attention to detail.</p>
                        </div>
                        <Link to="/" className='link-approach'>
                            <button className='button-89-2'>View Our Gallery</button>
                        </Link>
                    </div>
                </div>
                <div className='approach-container-main-content1-content2'>
                    {data.map((item, index) => (
                        <div
                            style={{
                                borderTop: index == 0 && " 1px solid #EEE9E9"
                            }}
                            className='approach-container-main-content1-content2-content1'
                            key={index}
                        >
                            <div className='approach-container-main-content1-content2-content1-content1'>
                                <img src={item.img} alt={`${item.heading} Process`}/>
                            </div>
                            <div className='approach-container-main-content1-content2-content1-content2'>
                                <h1 className='heading-small'>{item.heading}</h1>
                                <p className='paragraph'>{item.para}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Approach2;
